export default "__VITE_ASSET__Cq20xGgD__"